import {
  LayoutDashboard,
  FileText,
  ListChecks,
  CreditCard,
  BookOpen,
  BarChart3,
  ClipboardCheck,
  Bell,
  Settings,
  Shield,
  ScrollText,
  Sparkles,
  type LucideIcon,
} from 'lucide-react';

import type { AuthUser } from '@/stores/auth';

export interface NavItem {
  labelKey: string;
  to: string;
  icon: LucideIcon;
  roles?: AuthUser['role'][];
  badgeKey?: string;
}

export interface NavGroup {
  labelKey?: string;
  items: NavItem[];
}

/**
 * Sidebar navigation. The "Translate" entry is the primary action and lives at
 * the top so users land on it instantly. Everything else stays grouped by area.
 */
export const navGroups: NavGroup[] = [
  {
    items: [
      { labelKey: 'nav.dashboard', to: '/', icon: LayoutDashboard },
      { labelKey: 'nav.translate', to: '/translate', icon: Sparkles },
      { labelKey: 'nav.documents', to: '/documents', icon: FileText },
      { labelKey: 'nav.jobs', to: '/jobs', icon: ListChecks },
    ],
  },
  {
    labelKey: 'nav.groups.workflow',
    items: [
      { labelKey: 'nav.review', to: '/review', icon: ClipboardCheck, roles: ['staff', 'org_admin', 'super_admin'] },
      { labelKey: 'nav.glossary', to: '/glossary', icon: BookOpen },
      { labelKey: 'nav.analytics', to: '/analytics', icon: BarChart3 },
    ],
  },
  {
    labelKey: 'nav.groups.account',
    items: [
      { labelKey: 'nav.billing', to: '/billing', icon: CreditCard },
      { labelKey: 'nav.notifications', to: '/notifications', icon: Bell },
      { labelKey: 'nav.settings', to: '/settings', icon: Settings },
    ],
  },
  {
    labelKey: 'nav.groups.administration',
    items: [
      { labelKey: 'nav.admin', to: '/admin', icon: Shield, roles: ['staff', 'super_admin'] },
      { labelKey: 'nav.audit', to: '/audit', icon: ScrollText, roles: ['org_admin', 'super_admin'] },
    ],
  },
];

export function filterNavGroups(
  groups: NavGroup[],
  role: AuthUser['role'] | undefined,
): NavGroup[] {
  return groups
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => !item.roles || (role && item.roles.includes(role))),
    }))
    .filter((group) => group.items.length > 0);
}
